import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysInvoice } from '../queryKeys';

import {
  type UpdateLineItemMutationOptions,
  type UpdateLineItemVariables,
} from './types';
import { updateLineItem } from './updateLineItem';

/**
 * React Query mutation for updating editable invoice line-item values.
 *
 * @param options - Optional mutation configuration.
 * @returns Mutation state and methods.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/update_line_item_invoices__invoice_id__line_items__line_item_id__patch
 */
export function useMutationUpdateLineItem(
  options?: UpdateLineItemMutationOptions,
) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: (variables: UpdateLineItemVariables) =>
      updateLineItem(variables),
    onSettled(data, error, variables, onMutateResult, context) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysInvoice.getDetail(variables.invoiceId),
      });

      return options?.onSettled?.(
        data,
        error,
        variables,
        onMutateResult,
        context,
      );
    },
  });
}
